import axiosInstance from '../utils/axiosInstance';


export const getDashboardStats = async () => {
  try {
    const response = await axiosInstance.get('/stats');
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to load stats');
  }
};